import React from "react";
import { Phone } from "lucide-react";
import { SITE } from "../lib/constants";

export const MobileCallButton = () => {
  return (
    <a
      href={`tel:${SITE.phone.replace(/\s/g, "")}`}
      data-testid="mobile-call-button"
      aria-label="Call Divy now"
      className="hidden fixed bottom-6 left-6 z-40 group"
    >
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#D4AF37] hover:bg-[#E6C35C] transition-colors shadow-[0_8px_30px_rgba(212,175,55,0.45)]">
        <Phone className="w-5 h-5 text-black" />
      </span>
    </a>
  );
};
